import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Badge } from "../Badge/index.js";
import { Disc } from "../Disc/index.js";
import { Heading } from "../Heading/index.js";
import { PlainButton } from "../PlainButton/index.js";
import { sellingPointVariants } from "./SellingPoint.variants.js";
function SellingPoint({ badge, heading, body, disc, palette = 'neutral', emphasis = 'regular', orientation = 'horizontal', size = 'md', handleClick, actionLabel }) {
    const { baseSlot, discSlot, badgeSlot, actionSlot, mainContentContainerSlot } = sellingPointVariants({
        palette,
        emphasis,
        orientation,
        size
    });
    const headingSize = 'sm' === size ? 'h6' : 'h5';
    const discSize = 'sm' === size ? 'sm' : 'md';
    const badgeEmphasis = 'regular' === emphasis ? 'medium' : 'regular';
    const discEmphasis = 'regular' === emphasis ? 'medium' : 'regular';
    return /*#__PURE__*/ jsxs("div", {
        className: baseSlot(),
        children: [
            /*#__PURE__*/ jsx("div", {
                className: discSlot(),
                children: getDiscComponent(disc, palette, discEmphasis, discSize)
            }),
            /*#__PURE__*/ jsxs("div", {
                className: mainContentContainerSlot(),
                children: [
                    badge ? /*#__PURE__*/ jsx("div", {
                        className: badgeSlot(),
                        children: getBadgeComponent(badge, palette, badgeEmphasis)
                    }) : null,
                    heading ? /*#__PURE__*/ jsx(Heading, {
                        as: headingSize,
                        children: heading
                    }) : null,
                    body ? /*#__PURE__*/ jsx("div", {
                        className: "text-body2",
                        children: body
                    }) : null,
                    actionLabel && handleClick ? /*#__PURE__*/ jsx("div", {
                        className: actionSlot(),
                        children: /*#__PURE__*/ jsx(PlainButton, {
                            onClick: handleClick,
                            textStyle: "body2",
                            type: "primary",
                            children: actionLabel
                        })
                    }) : null
                ]
            })
        ]
    });
}
function getDiscComponent(disc, palette, emphasis, size) {
    if ('string' == typeof disc && disc) return /*#__PURE__*/ jsx(Disc, {
        content: disc,
        contentType: "icon",
        palette: palette,
        emphasis: emphasis,
        size: size
    });
    if ('object' == typeof disc && disc) return /*#__PURE__*/ jsx(Disc, {
        ...disc,
        palette: palette,
        emphasis: emphasis,
        size: size
    });
    return null;
}
function getBadgeComponent(badge, palette, emphasis) {
    if ('string' == typeof badge && badge) return /*#__PURE__*/ jsx(Badge, {
        palette: palette,
        size: "sm",
        emphasis: emphasis,
        children: badge
    });
    if ('object' == typeof badge && badge) return /*#__PURE__*/ jsx(Badge, {
        ...badge,
        palette: palette,
        size: "sm",
        emphasis: emphasis
    });
    return null;
}
export { SellingPoint };
